import React from "react";
import { useParams } from "react-router-dom";
import DesignSiteForm from "./design_site_form";

const EditDesignSite: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <DesignSiteForm mode="edit" siteId={id} />;
};

export default EditDesignSite;
